export let unflaggedDueDateGroupLabel = "Wz5jUc";
export let noDateGroupLabel = "Ita9nd";
export let laterGroupLabel = "ry2Emc";
export let nextWeekGroupLabel = "w5_Sx";
export let thisWeekGroupLabel = "x40Zqb";
export let tomorrowGroupLabel = "KHSVY";
export let todayGroupLabel = "eR8ku";
export default {unflaggedDueDateGroupLabel,noDateGroupLabel,laterGroupLabel,nextWeekGroupLabel,thisWeekGroupLabel,tomorrowGroupLabel,todayGroupLabel};